import axios from '../../axios'

export const getTickets = async () => {
  try {
    const response = await axios.get('/v1/admin/tickets')

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const getTicket = async (id) => {
  try {
    const response = await axios.get(`/v1/admin/tickets/${id}`)

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const createTicket = async (ticket) => {
  try {
    const response = await axios.post('/v1/admin/tickets', ticket)

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const sendTicket = async (id, ticket) => {
  try {
    const response = await axios.put(`/v1/admin/tickets/${id}`, ticket)

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const uploadFile = async (file) => {
  try {
    let data = new FormData()
    data.append('file', file, file.name)

    const response = await axios.post('/v1/cdn/upload', data)
    if (response.data.success) {
      return response.data.data
    }
  } catch (err) {
    console.log(err)
  }
}

export const updateTicketLevel = async (id, level) => {
  try {
    const response = await axios.put(`/v1/admin/tickets/${id}/level`, { level })

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}
